import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';

export interface ChatDateSeparatorProps {
  /** 日期文本 */
  date: string;
  /** 容器样式 */
  style?: ViewStyle;
  /** 文本样式 */
  textStyle?: TextStyle;
}

/**
 * 聊天日期分隔符组件
 * 
 * 用于在消息列表中显示日期分隔线
 * 
 * @example
 * ```tsx
 * <ChatDateSeparator date="今天" />
 * ```
 */
export const ChatDateSeparator: React.FC<ChatDateSeparatorProps> = ({
  date,
  style,
  textStyle,
}) => {
  return (
    <View style={[styles.container, style]}>
      <Text style={[styles.text, textStyle]}>
        {date}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginVertical: 16,
  },
  text: {
    fontSize: 12,
    color: '#999',
    backgroundColor: '#fff',
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
    overflow: 'hidden',
  },
});
